import { AdditionalCostRestEndpointService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import type { AccountingCostBody } from '@/modules/accounting/types.ts'
import { handleError } from '@/utils/error'

export function useCreateAdditionalCost() {
  const toast = useToast()
  const queryClient = useQueryClient()

  const createCostMutation = useMutation(
    (body: Partial<AccountingCostBody>) =>
      AdditionalCostRestEndpointService.dashboardCreateAdditionalCost({
        requestBody: {
          amount: Number(body.amount),
          name: body.name,
          typeId: body.typeId,
          valid: body.valid,
          retention: body.retention,
        },
      }),
    {
      onSuccess: () => {
        toast.success('Additional cost successfully created')
        queryClient.invalidateQueries(['additional-costs'])
      },
      onError: (error) => {
        handleError(
          error,
          'Error occurred while creating cost, please try again',
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries(['accounting_data'])
      },
    },
  )

  const createCost = (body: Partial<AccountingCostBody>) => {
    return createCostMutation.mutateAsync(body)
  }

  return {
    createCost,
    isLoading: createCostMutation.isLoading,
  }
}
